import * as Sentry from "@sentry/react";
import {
  TRACKING_ENDPOINT_PATH,
  trackingAnalyticsService,
} from "../../services/api/tracking-analytics.endpoints";
import store from "../../store";

// Tracking is fire-and-forget: failures are reported to Sentry only and never
// surface in the UI or escape as unhandled promise rejections
export const postAnalyticsTracking = async (
  data: any,
  oauthTokenHeader: string,
) => {
  try {
    await trackingAnalyticsService.postAnalyticsTracking(
      data,
      oauthTokenHeader,
    );
  } catch (e: any) {
    // fetchWrapper rejects non-2xx responses with { status, parsedText, ... }
    if (e?.status === 403) {
      Sentry.captureMessage(`403 Forbidden on ${TRACKING_ENDPOINT_PATH}`, {
        level: "warning",
        tags: { endpoint: TRACKING_ENDPOINT_PATH },
        extra: {
          requestBody: data,
          responseMessage: e?.parsedText,
          organizationName:
            store.getState().user.userData?.data?.user_details
              ?.organization_name,
        },
      });
      return;
    }
    Sentry.captureException(e, {
      tags: { endpoint: TRACKING_ENDPOINT_PATH },
      extra: { requestBody: data, status: e?.status },
    });
  }
};
